import React from "react";
import styled from "styled-components";
import { Box, Image } from "@chakra-ui/core";
import { withRouter } from "react-router-dom";
import { ModalFullScreen } from "modules/common/UI";
import { theme } from "theme";
import chevron from "assets/images/navbar/chevron-right.svg";
import IconBandeiraMobile from "assets/images/hub/icon-bandeira-mobile.png";
import IconArrow from "./IconArrow";
import { useAnchor } from "hooks/useAnchor";

const Menu = (props) => {
  const { scrollToAnchor } = useAnchor({offset: 0});

  return (
    <ModalFullScreen
      onClose={props.onClose}
      ref={props.ref}
      isOpen={props.isOpen}
    >
      <MyList>
        <MyLine
          onClick={ (e) => {
              e.preventDefault();
              window.history.pushState(null, "", "#promocoes");
              scrollToAnchor("promocoes");
              props.onClose();
            }
          }
        >
          <Label>Promoções</Label>
          <Image src={chevron} color={theme.color.orange} />
        </MyLine>

        <MyLine
          onClick={ (e) => {
              e.preventDefault();
              window.history.pushState(null, "", "#para-voce");
              scrollToAnchor("para-voce");
              props.onClose();
            }
          }
        >
          <Label>Para Você</Label>
          <Image src={chevron} color={theme.color.orange} />
        </MyLine>

        <MyLine
          onClick={ (e) => {
              e.preventDefault();
              window.history.pushState(null, "", "#para-seu-veiculo");
              scrollToAnchor("para-seu-veiculo");
              props.onClose();
            }
          }
        >
          <Label>Para o seu Veículo</Label>
          <Image src={chevron} color={theme.color.orange} />
        </MyLine>
         
        <MyLineNew>
          <a href="https://www.shell.com.br/sobre-a-shell/fale-conosco" target="_blank">
            <Label>Ajuda</Label>
            <Image src={chevron} color={theme.color.orange} />
          </a>
        </MyLineNew>
      </MyList>
    </ModalFullScreen>
  );
};

export default withRouter(Menu);

const MyList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const MyLine = styled.li`
  height: 60px;
  border-bottom: 1px solid ${(props) => props.theme.color.mediumGray};
  padding: 0 1.2em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > svg {
    path {
      stroke: ${props => props.theme.color.orange};
    }
  }
`;

const MyLineNew = styled.li`
  border-bottom: 1px solid ${(props) => props.theme.color.mediumGray};
  a {
    height: 60px;
    padding: 0 1.2em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
  }
  & > svg {
    path {
      stroke: ${props => props.theme.color.orange};
    }
  }
`;

const Label = styled(Box)`
  font-weight: 500;
  font-size: 20px;
  line-height: 14px;
  color: ${(props) => props.color ? props.color : props.theme.color.gray};
`;

const MyLink = styled.a`
  height: 4.5rem;

  padding: 0 1.2em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  background: url(${IconBandeiraMobile});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: ${props => props.theme.Shell.Bold};
  
  ${Label} {
    margin-bottom: 4px;
  }

  & > svg {
    path {
      stroke: ${props => props.theme.color.white} !important;
    }
  } 
`;